import { render, staticRenderFns } from "./posterSimple.vue?vue&type=template&id=0e3877d6&scoped=true"
import script from "./posterSimple.vue?vue&type=script&lang=js"
export * from "./posterSimple.vue?vue&type=script&lang=js"
import style0 from "./posterSimple.vue?vue&type=style&index=0&id=0e3877d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3877d6",
  null
  
)

export default component.exports